import { Injectable } from '@angular/core';
import { FormBase } from '@mapfre-design-library/src/public_api';
import { FormBaseInputsService } from '@services/common/form-base-inputs.service';

@Injectable({
  providedIn: 'root',
})
export class AddPolicyService {
  constructor(private formBaseInputsService: FormBaseInputsService) {}
  getInputs() {
    const inputs: FormBase<any>[] = [
      this.formBaseInputsService.getAddPolicyInput(),
    ];
    return inputs;
  }

  getLinkInputs() {
    const inputs: FormBase<any>[] = [      
      this.formBaseInputsService.getAddPolicyInput(),
      this.formBaseInputsService.getZipCodeInput(),
    ];
    return inputs;
  }
}
